import { Subject, Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

interface BroadcastEvent<T = unknown> {
    key: string;
    data?: T;
}

/** A purely static event bus: every member is static, so it is never injected or instantiated. */
export class BroadcastService {
    private static _eventBus = new Subject<BroadcastEvent>();

    public static broadcast<T>(key: string, data?: T): void {
        this._eventBus.next({ key, data });
    }

    public static on<T>(key: string): Observable<T> {
        return this._eventBus.asObservable().pipe(
            filter((event) => event.key === key),
            map((event) => event.data as T),
        );
    }
}
